import { render, staticRenderFns } from "./PdaLogin.vue?vue&type=template&id=4589de79"
import script from "./PdaLogin.vue?vue&type=script&lang=js"
export * from "./PdaLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports